var map = {
	"./Cyprus.json": [
		4054,
		54
	],
	"./Greece.json": [
		7850,
		850
	],
	"./Italy.json": [
		4777,
		777
	],
	"./Netherlands.json": [
		5687,
		687
	],
	"./Poland.json": [
		552,
		552
	],
	"./Romania.json": [
		7159,
		159
	],
	"./Slovenia.json": [
		3694,
		694
	],
	"./Spain.json": [
		5589,
		589
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1013;
module.exports = webpackAsyncContext;